"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffRole = exports.StaffAccess = void 0;
var StaffAccess;
(function (StaffAccess) {
    StaffAccess["Admin"] = "Admin";
    StaffAccess["Staff"] = "Staff";
    StaffAccess["Manager"] = "Manager";
    StaffAccess["CEO"] = "CEO";
    StaffAccess["Accountant"] = "Accountant";
    StaffAccess["All"] = "All";
})(StaffAccess || (exports.StaffAccess = StaffAccess = {}));
var StaffRole;
(function (StaffRole) {
    StaffRole["ADMIN"] = "Admin";
    StaffRole["MANAGER"] = "Manager";
    StaffRole["SALES_ASSOCIATE"] = "Sales Associate";
    StaffRole["SHIFT_SUPERVISOR"] = "Shift Supervisor";
    StaffRole["CASHIER"] = "Cashier";
    StaffRole["CUSTOMER_SERVICE"] = "Customer Service";
    StaffRole["INVENTORY_SPECIALIST"] = "Inventory Specialist";
    StaffRole["DELIVERY_PERSON"] = "Delivery Person";
    StaffRole["SOFTWARE_ENGINEER"] = "Software engineer";
    StaffRole["CEO"] = "CEO";
    StaffRole["MARKETING"] = "Marketing and social medal";
    StaffRole["ACCOUNTANT"] = "Accountant and HR";
})(StaffRole || (exports.StaffRole = StaffRole = {}));
//# sourceMappingURL=staff.js.map